import React, { Component } from 'react';

import { Animated_phone } from '../../Images/HeaderSVG';

export default class AnimatedPhone extends Component {
    constructor(props) {
        super(props);
      }

    render() {
        return (
            <div className={`Animation_Container ${this.props.isPreview &&'preview'}`}>
                <div className="Layer_6">
                    <div className="Layer_9"></div>
                </div>
                <div className="Layer_4"></div>
                <div className="Layer_5"></div>

                <div id="Layer_3">{Animated_phone}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Animations/AnimatedPhone.jsx